import React, { useState, useEffect, useRef } from "react";
import "./../BlogPage.css";
import blog_img from '../../../assets/HomePage/Blogs/Blog1.png'
import { GoDotFill } from "react-icons/go";
import { Col, Row } from "react-bootstrap";
import Header1 from '../../HeaderComponent1/Header1';
import Header from '../../HeaderComponent/Header';
import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";

const data = [
  {
    title: "What is Angular Full Stack?",
    description:"Angular Full Stack is a development approach that combines Angular for the front end with back-end technologies like Node.js. Express.js, or Spring Boot, and a database to create full-featured web applications. This combination helps developers build modern, efficient, and scalable web applications. ",
    publishedDate: 'Feb 18, 2025', readTime: "8 min",
    content: [
      {
        title: "Frontend Angular Framework ",
        description: "Angular A TypeScript-based framework by Google for building dynamic and responsive single-page applications (Spas). ",
        list:[
              {
                heading:"Data binding : ",
                point:"Two-way data binding for real-time UI updates. "
              },
              {
                heading:"Component-based: ",
                point:" architecture for modular development. "
              },
              {
                heading:"Dependency: ",
                point:"Built-in dependency injection and powerful RxJS support. "
              },
              {
                heading:"Faster: ",
                point:"Angular CLI for faster setup, testing, and deployment. "
              } 

            ]
      },
      {
        title: "Backend Framework  ",
        description: "RESTful APIs or GraphQL are used to facilitate communication between the Angular front-end and the back-end services. ",
        list:[
              {
                heading:"Node.js: ",
                point:"A runtime for JavaScript that allows developers to write server-side code. "
              },
              {
                heading:"Express.js: ",
                point:"A web application framework for Node.js, providing robust routing and middleware support. "
              },
              {
                heading:"Spring Boot: ",
                point:"For Java developers. "
              },
              {
                heading:"Django:  ",
                point:"For Python-based projects. "
              } 

            ]
      },
      {
        title: "Database  ",
        description: "",
        list:[
              {
                heading:"NoSQL Databases: ",
                point:"MongoDB is used with Angular Full stack because it stores data like JSON, matching Agular’s structure. "
              },
              {
                heading:"Relational Databases: ",
                point:"MySQL, PostgreSQL, or SQLite can be used if structured data with relationships is required."
              },
              {
                heading:"Spring Boot: ",
                point:"For Java developers. "
              },
              {
                heading:"Django:  ",
                point:"For Python-based projects. "
              } 

            ]
      },
      {
        title: "Development Tools ",
        description: "",
        list:[
              {
                heading:"Angular CLI: ",
                point:"Helps developers quickly create, test, and deploy Angular projects."
              },
              {
                heading:"NPM/Yarn: ",
                point:"For managing back-end dependencies. "
              },
              {
                heading:"Webpack: ",
                point:"Used for bundling JavaScript modules. "
              },
              {
                heading:"Postman/Swagger: ",
                point:" For testing APIs. "
              },
              {
                heading:"Git: ",
                point:"Version control for codebase management. "
              } 
            ]
      },
      {
        title: "Advantages of Using Angular Full Stack ",
        description: "JavaScript/TypeScript is used throughout (frontend, backend, and sometimes even the database), making it easier for developers to switch contexts. ",
        list:[
              {
                heading:"Scalability: ",
                point:"Both Angular and Node.js are designed to handle high traffic applications and large datasets effectively. "
              },
              {
                heading:"Reusable Code: ",
                point:"Component-driven development in Angular allows reusability and modularity. "
              },
              {
                heading:"Real-Time Capabilities: ",
                point:"Using WebSockets (via libraries like Socket.io), developers can build real-time applications such as chat systems or live dashboards. "
              },
              {
                heading:"Full Control of Development: ",
                point:"Developers can handle both the frontend and backend of the application, making collaboration and debugging more seamless. "
              } 
            ]
      },
      {
        title: "Popular Tools and Technologies for Angular Full Stack Development ",
        description: "",
        list:[
              {
                heading:"Frontend: ",
                point:"Angular, Angular Material, Bootstrap. "
              },
              {
                heading:"Backend: ",
                point:"Node.js, Express.js, NestJS, Spring Boot. "
              },
              {
                heading:"Databases: ",
                point:"MongoDB (NoSQL). MySQL, PostgreSQL (SQL)."
              },
              {
                heading:"Authentication: ",
                point:"JSON Web Tokens (JWT), OAuth2. "
              },
              {
                heading:"Testing: ",
                point:"Jasmine, Karma, Protractor, Mocha, Chai, Jest. "
              },
              {
                heading:"Version Control: ",
                point:"Git, GitHub/GitLab/Bitbucket. "
              },
              {
                heading:"Build Tools:",
                point:"Docker, Kubernetes. "
              },
              {
                heading:"Deployment Platforms: ",
                point:"AWS, Firebase, Vercel, Netlify. "
              }       
            ]
      },
      {
        title: "Real-World Example Stack ",
        description: "",
        list:[
              {
                heading:"Frontend: ",
                point:"Angular with Angular Material for UI. "
              },
              {
                heading:"Backend: ",
                point:"Node.js + Express.js. "
              },
              {
                heading:"Databases: ",
                point:"MongoDB for data storage. "
              },
              {
                heading:"Authentication: ",
                point:"JWT for secure user login. "
              },
              {
                heading:"Testing: ",
                point:"Socket.io for live notifications or messaging. "
              } 
            ]
      }
    ],
  }
];


function BlogDetailsPage2() {
  const location = useLocation();
  const index = location.state?.index || 0;
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [selectedBlog, setSelectedBlog] = useState(data[index < data.length ? index || 0 : 0]);
  const detailsRef = useRef(null);
  const [header, setHeader] = useState(false);
  const countingRef = useRef([]);
  const setRef = (element, index) => {
    countingRef.current[index] = element;
  };
  const [isIntersecting, setIsIntersecting] = useState([]);
  const handleIntersection = (entries) => {
    const newVisibility = [...isIntersecting];

    entries.forEach(entry => {
      const index = countingRef.current.indexOf(entry.target);
      if (index !== -1) {
        newVisibility[index] = entry.isIntersecting;
      }
    });

    setIsIntersecting(newVisibility);
  };
  useEffect(() => {
    const options = {
      threshold: 0.5, // Adjust as needed
    };
    const countRef = countingRef
    const observer = new IntersectionObserver(handleIntersection, options);

    countRef.current.forEach(ref => {
      if (ref) {
        observer.observe(ref);
      }
    });

    return () => {
      // Cleanup
      countRef.current.forEach(ref => {
        if (ref) {
          observer.unobserve(ref);
        }
      });
    };

  }, []);

  useEffect(() => {
    // window.scrollTo(0, 0);

    if (window.innerWidth > 1000) {
      setHeader(true)
    }
    // handleScrollTo(isIntersecting.length-1)
    console.log("view :", isIntersecting.length)

  }, [isIntersecting])

  // Handle scroll to selected description
  const handleScrollTo = (index) => {
    setSelectedIndex(index);
  };

  // Handle manual scroll to update the selectedIndex
  const handleScroll = () => {
    if (detailsRef.current) {
      const container = detailsRef.current;
      const descriptions = Array.from(
        container.querySelectorAll(".description-item")
      );
      const scrollTop = container.scrollTop;
      for (let i = 0; i < descriptions.length; i++) {
        const description = descriptions[i];
        if (description.offsetTop >= scrollTop) {
          setSelectedIndex(i);
          break;
        }
      }
    }
  };

  return (
    <>
    <Helmet>
    <title>What is Angular Full Stack?</title>
    <link rel="canonical" href="https://visheshcountrycache.com/codeslide-tech-news" />
    <meta name='description' content='Stay updated with the latest tech news and advancements in coding. Discover insightful articles and tutorials with code slides to boost your programming skills on our platform ' />
    <meta name='keywords' content='codeslide tech news,tech news, vishesh country cache Private Limited, software companies in village,software development company, top 10 software companies in india, software solutions company, software engineering companies, vacancies in small software companies for freshers, software development companies near me, 
    data software research company, software company jobs, best companies for software engineers, best software development company, internship in software company, software consulting companies, vishesh country cache software company, vishesh country cache private limited in undrajavaram, software company, 
    software company near me, vishesh software company in tanuku, software companies in tanuku, best digital marketing company near me, best digital marketing company in tanuku, website development company, best marketing analysis company in tanuku, best software company in city out cuts, top software companies in tanuku, 
    best logo design agency,logo design,best video editing near me, graphic desingers,best graphic design agencies,top marketing analytics companies best data analyst jobs,top data analytics companies,web developer jobs for freshers,jobs in web development for freshers,fornted developers near me,best backend developers near me' />
    <meta name="author" content="Vishesh Country Cache" />
    <meta name="robots" content="index, follow" />
    <html lang="en" />
  </Helmet>
      {header ? <Header1 /> : <Header />}
      <div className="image-text-row">
        <img src={blog_img} alt="Blog" className="blog-image-sec" />
        <h4 className="blog-title">What is Angular Full Stack?</h4>
        <div className='reviews-para bolg-page-text'>{selectedBlog.publishedDate} <GoDotFill style={{ fontSize: 12, background: "transparent" }} /> {selectedBlog.readTime} read</div>
      </div>
      <div className="details-body">
        <div>
          <Row className="carousel-row">
            <Col xs={12} md={4} className="carousel-container">
              <div className="titles-container">
                {selectedBlog.content.map((item, index) => (
                  <a href={`#Content${index}`} style={{ textDecoration: "none", color: '#33353a', width: 300, backgroundColor: "red" }} key={index}>
                    <div className={`title-item  ${selectedIndex === index ? "active" : ""}`}
                      onClick={() => { handleScrollTo(index); }} >
                      {item.title}
                    </div>
                  </a>
                ))}
              </div>
            </Col>
            <Col xs={12} md={8} className="carousel-details" ref={detailsRef} onScroll={handleScroll}>
              <p className="sub-description" style={{ marginBottom: "2rem" }}>{selectedBlog.description}</p>
              {selectedBlog.content.map((item, index) => (
                <div className="details-container" ref={(element) => setRef(element, index)} >
                  <div
                    key={index}
                    id={`description-${index}`}
                    className={`description-item ${"active-description"}`}
                  >
                    <h6 className="description-heading" id={`Content${index}`}>{item.title}</h6>
                    <p className="sub-description">{item.description}</p>
                    <ul style={{ background: "transparent" }}>

                      {
                        item.list.map((listItem)=>{
                              return (
                                <li className="item-list-sunpoint">
                                  <span style={{ fontWeight: "bold", background: "transparent" }}>
                                    {listItem.heading}
                                  </span> {listItem.point}
                                </li>
                              )
                          })
                      }
                    </ul>
                  </div>
                </div>
              ))}
            </Col>
          </Row>

        </div>
      </div>
    </>
  );
}

export default BlogDetailsPage2